"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MuiBadge = void 0;
var colors_1 = require("../../generated/colors");
exports.MuiBadge = {
    styleOverrides: {
        root: {
            "& .MuiBadge-badge": {
                fontWeight: 800,
                fontSize: "10px",
            },
        },
    },
    variants: [
        {
            props: {
                color: "default",
            },
            style: {
                "& .MuiBadge-badge": {
                    background: colors_1.colors.WaveBlue200,
                    color: colors_1.colors.White,
                },
            },
        },
    ],
};
//# sourceMappingURL=badge.js.map